import React from 'react';
import '../styles/Legal.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-section">
            <h2>Introduction</h2>
            <p>
              JOY WORLDWIDE CONSULTANCY SERVICES (JWCS) is committed to protecting your privacy.
              This Privacy Policy explains how we collect, use, disclose, and safeguard your
              information when you visit our website or use our services.
            </p>
          </div>

          <div className="legal-section">
            <h2>Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Fill out forms on our website</li>
              <li>Submit your CV or resume</li>
              <li>Contact us via email or phone</li>
              <li>Subscribe to our newsletter</li>
              <li>Apply for job opportunities</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name, email address, and phone number</li>
              <li>Mailing address</li>
              <li>Employment history and qualifications</li>
              <li>Educational background</li>
              <li>Immigration status and work authorization</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide staffing and recruitment services</li>
              <li>Match candidates with suitable job opportunities</li>
              <li>Communicate with you about our services</li>
              <li>Process immigration and work permit applications</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Information Sharing</h2>
            <p>
              We may share your information with potential employers, partner organizations,
              and government agencies as necessary to provide our services. We do not sell
              your personal information to third parties.
            </p>
          </div>

          <div className="legal-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your
              personal information against unauthorized access, alteration, disclosure, or
              destruction.
            </p>
          </div>

          <div className="legal-section">
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> info@joywcs.com<br />
              <strong>Phone:</strong> +1 647-684-9045 (International) | +91 9380093605 (India)<br />
              <strong>Head Office:</strong> Office: C1 - 1F - SF7384, C1 Building, Ajman Free Zone, AJMAN, UAE<br />
              <strong>India Affiliate Office - BLUE COLLAR MANPOWER MGMT (BCMM):</strong> #52/2, 3rd Floor, 1st Main, "Mutthappa Reddy Heights", diagonally opp. Gopalan Signature Mall, Old Madras Road, Benniganahalli, Doorvaninagar, Bengaluru 560016, Karnataka.
            </p>
          </div>

          <div className="legal-section">
            <h2>Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any
              changes by posting the new Privacy Policy on this page and updating the
              "Last Updated" date.
            </p>
            <p><strong>Last Updated:</strong> December 2024</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
